export const defaultLimit = 6;
export const filesSizeLimitInBytes = 4194304;
export const defaultFadeInAnimationVars = {
    initial: {
        opacity: 0,
        y: 100,
    },
    animate: () => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.75,
            ease: 'easeInOut',
        },
    }),
};

export const fadeInAnimationVars = {
    initial: {
        opacity: 0,
        y: 100,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            delay: 0.3,
        },
    },
};

export const salePrice = '$249';
export const regularPrice = '$449';
